import React from 'react';
import DealPrice from '../../../DealPrice.react';

export const PriceToChargeInfoBlock = ({
    t,
    hasDifferentDisplayCurrency,
    profile,
    DEAL,
    agent_pricing_props,
    contractClientCompanyId,
    HOTEL_IN_ISRAEL,
    TOTAL_PRICE,
}) => {

    return (
        <div
            className={`total-price-wrap flex align-center space-between${hasDifferentDisplayCurrency ? ' price-converted-wrap' : ''}`}
        >
            <span className="title">{t('DealDetails.Total')}</span>
            {profile.agent ? (
                <DealPrice
                    displayTotalPrice={false}
                    supplier={DEAL.supplier_name}
                    currency={DEAL.currency}
                    price={DEAL.totalPrice}
                    totalPrice={DEAL.totalPrice}
                    netPrice={DEAL.net_price_total}
                    commission={DEAL.commission_total}
                    dealId={DEAL.id}
                    profile={profile}
                    reservationMode={true}
                    {...agent_pricing_props}
                    contractClientCompanyId={contractClientCompanyId}
                />
            ) : (
                <React.Fragment>
                    <div className="price-value-wrap">
                        <span>
                            {HOTEL_IN_ISRAEL || hasDifferentDisplayCurrency ? '*' : null}
                            {TOTAL_PRICE}
                        </span>
                    </div>
                </React.Fragment>
            )}
        </div>
    );
};
